import { trackProductAddedToList } from '@/features/shared/analytics/products'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { type ProductCardProduct } from '@/features/shop/components/ProductCard/types'
import { TextButton } from '@shipt/design-system-buttons'
import { ListAddIcon } from '@shipt/design-system-icons'
import { getQtyIncrementForProduct } from '@/features/shop/components/ProductCard/Utils'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { SkeletonConsumer } from '@/features/shared/components/SkeletonLoader'
import { DynamicAddAndCreateListDrawer } from '@/features/shop/components/Drawer/AddAndCreateListDrawer/DynamicAddAndCreateListDrawer'

export const AddToListButton = ({ product }: { product: ProductCardProduct }) => {
  const { openDialog } = useHandleDialog()

  const handleOpenListsDrawer = () => {
    trackElementClicked({
      list_index: 2,
      link_name: 'Add_to_list',
      type: 'button',
    })
    openDialog(DynamicAddAndCreateListDrawer, {
      products: [
        {
          product_id: product.id,
          quantity: getQtyIncrementForProduct(product),
        },
      ],
      track: ({ listName, listId, listIndex, subLocation = 'add_to_list_picker' }) => {
        trackProductAddedToList({
          listName,
          listId,
          subLocation,
          displayFormat: DISPLAY_FORMAT.VERTICAL,
          product,
          listIndex,
        })
      },
      isCart: false,
    })
  }

  return (
    <SkeletonConsumer height="20px" width="100px">
      <TextButton leadingIcon={ListAddIcon} size="md" onClick={() => handleOpenListsDrawer()}>
        Add to list
      </TextButton>
    </SkeletonConsumer>
  )
}
